import { Section } from 'components/section'
import { Animation } from './animation'
import { ColoredTitle } from 'components/colored-title'
import { Light } from 'styles/typography'
import DataWrapperChart from 'components/datawrapper'
import ContactInfo from 'components/contact-info'

import { ChapterFooter } from 'components/layout/chapter-footer'
import { authors } from './footer-data'

import coloredTitle_L from './images/ColoredTitle4_L.webp'
import coloredTitle_M from './images/ColoredTitle4_M.webp'
import coloredTitle_S from './images/ColoredTitle4_S.webp'
import { ParallaxPhoneRight } from './parallax/phone-right'
import { ParallaxPhoneLeft } from './parallax/phone-left'

export const Kazakhstan2 = () => {
  return (
    <>
      <Animation />
      <Section containerType="text">
        <p>
          Вечером в августе 2023 года жительница Алматы Улжан отправилась в бар
          возле дома. Спустя полтора часа она собралась уходить, но охранник
          заведения предложил проводить ее из соображений безопасности.
        </p>
        <p>
          По ее словам, охранник не вызывал у нее опасений. Девушка согласилась.
        </p>
        <p>
          Однако в подъезде ее дома, угрожая ножом, он изнасиловал ее и снял это
          на камеру телефона.
        </p>
        <p>
          Улжан предстояла тяжелая борьба за справедливость: от полицейских
          допросов, которые не щадили ее психику и эмоции, до публичной травли,
          после того, как преступник распространил в сети видео насилия.
        </p>
        <p>
          Спустя почти год после пережитого ей удалось победить: 23-летнего
          Динмухамеда Кудайбергена признали виновным в изнасиловании и
          приговорили к восьми годами в учреждении средней безопасности.
        </p>
        <p>
          <Light>
            Предупреждение: в материале присутствуют описания сцен насилия
          </Light>
        </p>
        <p>
          Этот материал – часть проекта{' '}
          <a
            href="https://voicesofthebrave.asia/"
            target="_blank"
            rel="noreferrer"
          >
            "Голоса смелых"
          </a>
          , посвященного гендерному насилию в Центральной Азии. Мы рассказываем
          истории женщин, переживших насилие, чтобы показать масштаб проблемы и
          дать голос тем, кто зачастую говорить не может.
        </p>
      </Section>
      <Section
        containerType="text"
        heading='"Полицейские ломились ко мне домой и угрожали"'
      >
        <p>
          До нападения Кудайбергена жизнь Улжан выглядела так: интересная работа
          в международной компании, уютный дом, счастливое материнство. После
          рождения ребенка Улжан ушла в декрет и не работала, пока ребенок не
          пошел в детский сад. В свободное время девушка делала мозаики, которые
          дарила друзьям и родственникам.
        </p>
        <p>
          После пережитого ее здоровье и самооценка пострадали, она поправилась
          на 10 кг, стала избегать любых публичных мероприятий и до сих пор не
          готова показывать свое лицо. Девушка признается, что каждый день – это
          борьба за нормальную жизнь.
        </p>
        <p>
          "Государство должно пересмотреть свой подход к таким делам. Система
          ломает пострадавших вместо того, чтобы их защищать. Меня заставляли
          прийти на очную ставку в день инцидента, несмотря на мое ужасное
          состояние", – рассказывает Улжан.
        </p>
        <p>
          Одна из адвокаток Улжан Жанна Мухамади сообщала, что дело об
          изнасиловании не регистрировали более 15 часов. Только после обращения
          в прокуратуру его внесли в реестр досудебных расследований.
        </p>
        <p>
          Кроме того, к Улжан домой приходили полицейские, требуя забрать
          заявление, убеждая, что ей будет сложно доказать произошедшее.
          Давление на нее оказывали и во время экспертизы и допросов.
        </p>

        <ParallaxPhoneRight />

        <p>
          "Полицейские ломились ко мне домой, угрожали и требовали забрать
          заявление. Это было изнурительно и унизительно. Я чувствовала себя
          абсолютно беспомощной", – говорит Улжан.
        </p>
        <p>
          По ее словам, полицейские посмотрели видео, которое снял насильник, и
          явились к ней домой под предлогом вручить повестку.
        </p>
        <p>
          "Теперь смотри, у тебя есть вариант сейчас написать отказное
          [заявление], чтобы дальше процесс не шел. Просто завтра тебе это
          доказать будет сложно", –{' '}
          <a
            href="https://orda.kz/ohrannik-bara-ugrozhal-nozhom-i-iznasiloval-devushka-obvinila-policiju-i-prokuraturu-v-bezdejstvii-378443/"
            target="_blank"
            rel="noreferrer"
          >
            говорили
          </a>{' '}
          полицейские, несколько раз повторяя, что им "вообще-то, без разницы".
        </p>
        <p>
          После упоминания адвоката их тон изменился. "Адвоката за сколько
          наняли? Я тебе просто скажу: 10-300 тысяч [тенге] вы просто так
          отдаете", – заявил один из полицейских, после чего начал дергать ручку
          входной двери, пока Улжан плакала.
        </p>
        <p>Произошедшее она описала как "страшное и унизительное" событие.</p>
        <p>
          Ее дело долго оставалось без движения: следователи сменялись один за
          другим, а допросы пострадавшей проводились снова и снова. До того как
          его передали следовательнице, Улжан сменили трех следователей. Новая
          следовательница дважды обращалась с ходатайством о помещении
          Кудайбергена в СИЗО, однако оба раза получала отказ. После завершения
          уголовного дела против Динмухамеда Кудайбергена следовательница ушла
          из полиции.
        </p>
        <DataWrapperChart
          title="Доля женщин-полицейских практически не меняется за последние годы&amp;lt;úspan&amp;gt;"
          ariaLabel="Column Chart"
          src="https://datawrapper.dwcdn.net/VNhuH/4/"
          height="462px"
        />
      </Section>
      <Section
        containerType="text"
        heading='"Пришлось заставить себя бороться, чтобы добиться справедливости"'
      >
        <p>
          Следующие несколько месяцев Улжан жила в состоянии сильнейшего страха
          и стресса, но благодаря поддержке близких смогла найти в себе силы
          бороться. Дело двигалось, но медленно. Улжан приходилось постоянно
          рассказывать одно и то же, снова и снова переживая события тех дней.
          Ей пришлось проходить многочисленные экспертизы, отвечать на одни и те
          же вопросы во время допросов, сталкиваться с бюрократическими
          проволочками и ждать решений, которые постоянно откладывались.
        </p>
        <p>
          "Я еле-еле заставляла себя жить. Единственная мысль, что у меня есть
          ребенок, держала меня на этом свете. Бывший муж меня поддерживал, как
          и все близкие. Алия, мой адвокат, помогала не только юридически, но и
          психологически. Она буквально вытаскивала меня из этих состояний.
          Инцидент произошел в августе, а более-менее я пришла в себя только
          спустя два-три месяца. Именно тогда я начала кампанию в СМИ. Пришлось
          заставить себя бороться, чтобы добиться справедливости", – говорит
          Улжан.
        </p>
        <p>
          В ноябре 2023 года она записала открытое обращение к президенту
          Касым-Жомарту Токаеву, где рассказала о бездействии полиции.
        </p>
        <p>
          Благодаря этому ее история получила широкий резонанс в СМИ и
          социальных сетях. После этого насильника задержали, но по другому делу
          – за нападение на человека.
        </p>
        <p>
          "Находясь под следствием, насильник совершил новое преступление, он
          ограбил мужчину. Тогда полиция среагировала быстро. А когда я
          говорила, что этот человек опасен, меня просто игнорировали", – с
          горечью отмечает Улжан.
        </p>
        <p>
          Десятого января 2024 года благодаря общественному резонансу
          прокуратура передала дело по факту изнасилования Улжан в суд Алматы.
        </p>
      </Section>
      <Section
        containerType="text"
        heading='"Так поступать с девочками нельзя"'
      >
        <p>
          Главной мотивацией Улжан идти до конца стал страх, что Кудайберген
          останется безнаказанным и продолжит насиловать других девушек. Она
          чувствовала ответственность не только за себя, но и за безопасность
          других девушек.
        </p>
        <p>
          В первый же день совместной работы, одна из адвокаток отвела в сторону
          Улжан, чтобы поговорить наедине. Она предостерегла девушку, что видео
          сольют в целях мести или в попытке ее опорочить.
        </p>
      </Section>

      <ColoredTitle src={[coloredTitle_S, coloredTitle_M, coloredTitle_L]} />

      <Section containerType="text">
        <p>
          "Мне все равно. Пусть хоть весь мир увидит эти видео. Мне все равно.
          Пусть. Он должен быть наказан, и такие люди, как он, должны знать, что
          так делать с девочками нельзя", – ответила Улжан.
        </p>
        <p>
          26 апреля в Алматы был{' '}
          <a
            href="https://kaztag.kz/ru/news/v-almaty-okhrannik-bara-poluchil-vosem-let-kolonii-za-iznasilovanie"
            target="_blank"
            rel="noreferrer"
          >
            оглашен
          </a>{' '}
          приговор: охранника бара Динмухамеда Кудайбергена приговорили к восьми
          годам лишения свободы за изнасилование. По словам Улжан, ключевые
          экспертизы подтвердили на видео факт насилия.
        </p>
        <p>
          Через несколько дней после приговора, когда Улжан думала, что самое
          тяжелое осталось позади, в сеть слили видео, которое снял Кудайберген.
        </p>
        <p>
          Из-за случившегося Улжан стала бояться выходить из дома: помимо видео,
          злоумышленники слили в сеть ее домашний адрес и номер телефона. Улжан
          вспоминает, что стресс и давление были настолько сильными, что у нее
          возникли суицидальные мысли. Несмотря на это, Улжан подала заявление в
          полицию и решила продолжать бороться.
        </p>
        <p>
          "Считаю, что информацию о деле слили, возможно, его адвокаты или
          родственники. Я буду заниматься этим, как только наберусь сил, потому
          что меня оклеветали и продолжают это делать. Сейчас главное –
          восстановить силы и действовать в правовом поле, буду требовать
          справедливости", – говорит она.
        </p>
        <p>
          Она признается, что ей страшно, но дело нужно довести до конца, а
          клевету остановить.
        </p>
        <p>
          "Я боюсь, что он выйдет через несколько лет и начнет все сначала: те
          же тиктоки, те же нападки на мое имя. Это ужасно изматывает, но я
          хочу, чтобы это прекратилось раз и навсегда. Каждая девушка, которая
          решается наказать своего насильника, делает огромный шаг вперед для
          всех нас. Это шаг к будущему, где насильники не смогут скрываться,
          полиция будет работать, а женщины будут чувствовать себя в
          безопасности. Такой Казахстан я хочу видеть", – делится Улжан.
        </p>
      </Section>
      <Section
        containerType="text"
        beforeTitle={<ParallaxPhoneLeft />}
        heading="Почему нужны женские полицейские участки в Казахстане?"
      >
        <p>
          История Улжан показывает необходимость специализированных женских
          полицейских участков, где пережившим насилие смогут предоставлять
          деликатный и профессиональный подход. Это не вопрос удобства, а способ
          минимизировать повторную травматизацию женщин, которые пытаются
          защитить свои права.
        </p>
        <p>
          Сегодня женщинам в Казахстане, пережившим насилие, приходится
          многократно пересказывать подробности, снова и снова переживая
          болезненные эмоции: сначала при подаче заявления, потом на медицинской
          экспертизе, после чего на очной ставке – и все это еще до суда.
        </p>
        <p>
          В то время как в странах Европы и США существуют центры
          противодействия сексуализированному насилию, где помощь оказывается в
          одном месте. Там работают медики, психологи, полицейские и эксперты и
          вместе создают безопасное и поддерживающее пространство.
        </p>
        <p>
          Например,{' '}
          <a href="https://rapecrisis.com/" target="_blank" rel="noreferrer">
            The Rape Crisis Center
          </a>{' '}
          в Сан-Антонио (Техас) предоставляет комплексную помощь жертвам
          сексуализированного насилия, включая медицинское обследование,
          психологическую поддержку и юридическое сопровождение, чтобы помочь
          пострадавшим восстановиться и получить защиту в безопасной среде.
        </p>
        <p>
          "Я считаю, что каждая пострадавшая должна иметь уверенность в том, что
          к ней отнесутся с уважением и пониманием. Это даст шанс на
          восстановление, а не сделает травму еще глубже", – подчеркивает Улжан.
        </p>
        <p>
          В апреле 2024 года вице-министр внутренних дел Игорь Лепеха{' '}
          <a
            href="https://www.zakon.kz/obshestvo/6431215-v-kazakhstane-khotyat-uvelichit-chislo-zhenshchinpolitseyskikh.html"
            target="_blank"
            rel="noreferrer"
          >
            заявил
          </a>{' '}
          о намерении увеличить число женщин в рядах полиции, особенно в
          подразделениях, расследующих случаи насилия в отношении женщин и
          детей. По последним данным, их число составляло 280 женщин, также
          планировалось увеличить их штат на 750 единиц по всей стране.
        </p>
        <p>
          Одна из адвокаток Улжан, Жанна Мухамади отмечает, что
          женщины-полицейские обладают более чутким подходом и вниманием к
          деталям, что делает их расследования более эффективными и
          качественными.
        </p>
        <DataWrapperChart
          title="Рейтинг некоторых стран мира по доле женщин-полицейских"
          ariaLabel="Bar Chart"
          id="datawrapper-chart-pLswS"
          src="https://datawrapper.dwcdn.net/pLswS/4/"
          height="788px"
        />
        {/*<iframe title="(Data-viz) Рейтинг некоторых стран мира по доле женщин-полицейских" aria-label="Bar Chart" id="datawrapper-chart-pLswS" src="https://datawrapper.dwcdn.net/pLswS/4/" scrolling="no" frameborder="0" style="width: 0; min-width: 100% !important; border: none;" height="788" data-external="1"></iframe><script type="text/javascript">!function(){"use strict";window.addEventListener("message",(function(a){if(void 0!==a.data["datawrapper-height"]){var e=document.querySelectorAll("iframe");for(var t in a.data["datawrapper-height"])for(var r,i=0;r=e[i];i++)if(r.contentWindow===a.source){var d=a.data["datawrapper-height"][t]+"px";r.style.height=d}}}))}();</script> */}
        <p>
          Однако после резонансного дела Улжан существенных изменений не
          произошло: пострадавших по-прежнему подвергают многочисленным допросам
          и очным ставкам, что лишь усугубляет травму. По словам Мухамади,
          несмотря на то, что расследованием дел о сексуализированном насилии
          теперь занимаются только женщины, этого недостаточно для полной защиты
          прав пострадавших. Женщины продолжают подвергаться многочисленным
          допросам, очным ставкам, которые травмируют их подробностями насилия.
        </p>
        <p>
          Сейчас Улжан по-прежнему живет в Алматы. Мысль о том, что насильник
          может выйти из тюрьмы и начать мстить, не дает ей покоя. Стресс и
          переживания сказались на ее здоровье.
        </p>
        <p>
          Чтобы помочь себе восстановиться, Улжан начала психотерапию. Это
          помогло: девушка чувствует себя значительно лучше и постепенно
          возвращается к жизни. Она занимается творчеством и старается больше
          времени проводить с ребенком. На прежнюю работу она пока не готова
          вернуться, но надеется найти себя в новой профессии.
        </p>
        <p>
          "Раньше считала себя слабой "девочкой-принцессой, выросшей в тепличных
          условиях". Мне казалось, что я хрупкая и беззащитная. Но потом все
          изменилось. Этот опыт встряхнул меня и открыл то, о чем я даже не
          догадывалась: я сильная. Настоящая. Это как будто пробудило во мне
          внутренние силы, о которых я раньше даже не подозревала, – говорит
          Улжан. – Теперь я точно знаю, что могу справиться с чем угодно, и эта
          уверенность в себе для меня – самое главное, что я вынесла из этого
          испытания".
        </p>
      </Section>
      <ContactInfo />

      <ChapterFooter authors={authors} />
    </>
  )
}
